import { render, staticRenderFns } from "./SimpleV1Table.vue?vue&type=template&id=58c415f3&scoped=true&"
import script from "./SimpleV1Table.vue?vue&type=script&lang=ts&"
export * from "./SimpleV1Table.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c415f3",
  null
  
)

export default component.exports